import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import ComponentTitle from '../shared/ComponentTitle';
import connect from 'connect-alt';
import _ from 'lodash';
import { orderByCriteria, groupByCriteria } from 'utils/OrderGroupByUtils';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';
import translate from '../../utils/translate';

const CLOSINGS_TYPE = {
  BANNER_TYPE: 'banner',
  FULLVIEW_TYPE: 'fullView'
};

const CLOSINGS_TITLE = {
  CLOSINGS_ALL: 'ALL',
  CLOSINGS_ALL_TEXT: 'All Closings '
};

@connect('Closings')
class ClosingsAlert extends Component {
  static propTypes = {
    type: PropTypes.oneOf(Object.values(CLOSINGS_TYPE)),
    ClosingsStore: PropTypes.object.isRequired
  }

  static contextTypes = {
    flux: PropTypes.object.isRequired
  }

  static defaultProps = {
    type: CLOSINGS_TYPE.BANNER_TYPE
  }

  componentWillMount() {
    const { flux } = this.context;
    flux.getActions('Closings').readClosingsStatus();
  }

  render() {
    const {
      type,
      ClosingsStore: {
        closingsStatus: {
          closings = ['closings']
        } = {}
      } = {},
      ...props
    } = this.props;

    const totalAlerts = closings.length;

    if (type === CLOSINGS_TYPE.BANNER_TYPE) {
      if (totalAlerts && closings[0] !== 'closings') {
        return <BannerAlert {...props} totalAlerts = {totalAlerts}/>;
      }
      return null;
    }
    return closings[0] !== 'closings' && <FullViewAlert {...props} closingsData = {closings}/>;
  }
}

class BannerAlert extends Component {
  static propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    text: PropTypes.string,
    textColor: PropTypes.string,
    numberColor: PropTypes.string,
    numberBackgroundColor: PropTypes.string,
    cornerStyle: PropTypes.oneOf(['round', 'soft', 'square']),
    backgroundColor: PropTypes.string,
    backgroundStyle: PropTypes.oneOf(['solid', 'outline']),
    outlineColor: PropTypes.string,
    destinationURL: PropTypes.string,
    totalAlerts: PropTypes.number,
  }

  static defaultProps = {
    title: 'Closings & Delays',
    text: 'See the latest closings in the area.',
    cornerStyle: 'square',
    backgroundStyle: 'solid'
  }

  render() {
    const {
      title,
      titleColor,
      text,
      textColor,
      numberColor,
      numberBackgroundColor,
      cornerStyle,
      backgroundColor,
      backgroundStyle,
      outlineColor: borderColor,
      destinationURL: href,
      totalAlerts
    } = this.props;

    const style = { backgroundColor, borderColor };

    const className = classNames(
      'Banner',
      { [`Banner-border--${cornerStyle}`]: cornerStyle },
      [`Banner-style--${backgroundStyle}`]
    );

    return (
      <div className="ClosingsAlert">
        <div className={className} style={style}>
          <a href={href} role="button" >
            <span className="Banner-title" style={{ color: titleColor }}>
              {title}
              <span className="Banner-title--colon">: </span>
              <span className="Banner-title--text" style={{ color: textColor }}>{text}</span>
            </span>
            <div className="Banner-circle">
              <span className="Banner-circle--number" style={{ color: numberColor, backgroundColor: numberBackgroundColor }}>{totalAlerts}</span>
            </div>
          </a>
        </div>
      </div>
    );
  }
}

class FullViewAlert extends Component {

  static propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    text: PropTypes.string,
    textColor: PropTypes.string,
    statusColor: PropTypes.string,
    closingsData: PropTypes.array,
    abstractText: PropTypes.string,
    backgroundColor: PropTypes.string,
    titleType: PropTypes.string,
    noClosingsAlertMessage: PropTypes.string,
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    title: 'Closings & Delays',
    titleColor: '#000000',
    abstractText: 'The following is a list of the current closings and delays for schools, governments, houses of worship and other organizations.',
    textColor: '#000000',
    statusColor: '#D0021B',
    backgroundColor: '#ffffff',
    titleType: TITLE_TYPE.PAGE_TITLE,
    noClosingsAlertMessage: "No closings at this time",
  }

  state = { categoryClosings: CLOSINGS_TITLE.CLOSINGS_ALL }

  _chooseCategory(category) {
    this.setState({
      categoryClosings: category
    });
  }

  _renderAlertDataTable(title, statusColor, alertsByGroup) {
    return (
      <AlertDataTable
        title={title}
        statusColor={statusColor}
        alertData={alertsByGroup}
      />
    );
  }

  render() {
    const {
      config: {
        appOptions: {
          language = 'en'
        } = {}
      } = {}
    } = this.context;

    const {
      title,
      titleColor,
      titleType,
      textColor,
      statusColor,
      abstractText: text,
      backgroundColor,
      closingsData,
      noClosingsAlertMessage,
    } = this.props;

    let { categoryClosings } = this.state;

    categoryClosings = categoryClosings === 'ALL' ? translate(`${CLOSINGS_TITLE.CLOSINGS_ALL}`, language) : categoryClosings;

    const alertsByGroup = groupByCriteria(closingsData, 'organization.category');
    const listCategory = _.keys(alertsByGroup);
    // set ALL category is the first element of listCategory array.
    listCategory.unshift(translate(`${CLOSINGS_TITLE.CLOSINGS_ALL}`, language));

    if (!closingsData.length) {
      return (
        <div className='ClosingsAlert FullView' style={{backgroundColor}}>
          <div className='FullView-box'>
            <NoClosingsAlert noClosingsAlertMessage={noClosingsAlertMessage}/>
          </div>
        </div>
      );
    }

    return (
      <div className='ClosingsAlert FullView' style={{backgroundColor}}>
        <div className='FullView-box'>
          <div className='FullView-title'>
            <ComponentTitle showArrow={false} title={title} color={titleColor} titleType={titleType}/>
            <div className='FullView-text' style={{color: textColor}}>
              {text}
            </div>
            <div className='FullView-button-container'>
            { _.map(listCategory, category => {
                return (
                  <span  onClick={() => this._chooseCategory(category)}>
                    <ClosingsButton activeBorder={categoryClosings === category} category={category}/>
                  </span>
                );
              })
            }
            </div>
            <div className='ClosingsButton-desktop'>
              { _.map(listCategory, category => {
                return category === categoryClosings &&
                  this._renderAlertDataTable(category, statusColor, (category === translate(`${CLOSINGS_TITLE.CLOSINGS_ALL}`, language)) ? closingsData : alertsByGroup[category]);})
              }
            </div>
            <div className='ClosingsButton-mobile'>
              { _.map(listCategory, category => {
                  return (category !== translate(`${CLOSINGS_TITLE.CLOSINGS_ALL}`, language)) && this._renderAlertDataTable(category, statusColor, alertsByGroup[category]);
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class AlertDataTable extends Component {
  static propTypes = {
    title: PropTypes.string,
    statusColor: PropTypes.string,
    alertData: PropTypes.array
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    title: 'Alert Title',
    statusColor: '#D0021B',
    alertData: []
  }

  _renderRow() {
    const { statusColor, alertData } = this.props;
    const list = orderByCriteria(alertData, 'organization.name');

    return list.map(item => {
      const {
        status,
        organization: {
          name = ''
        } = {}
      } = item;

      const colorStyle = {color: statusColor};

      return (
        <tr className='TableData-row'>
          <td className='TableData-cell-name hidden-xs'>{name}</td>
          <td style={colorStyle} className='TableData-cell-status hidden-xs'>{status}</td>

          <td className='TableData-cell-mobile'>
            <p>{name}</p>
            <span style={colorStyle}>{status}</span>
          </td>
        </tr>
      );
    });
  }

  render() {
    const {
      config: {
        appOptions: {
          language = 'en'
        } = {}
      } = {}
    } = this.context;

    const { title } = this.props;
    const closingsTitle = title.toUpperCase() === translate(`${CLOSINGS_TITLE.CLOSINGS_ALL}`, language) ? translate(`${CLOSINGS_TITLE.CLOSINGS_ALL_TEXT}`, language) : title;

    return (
      <div className='ClosingsAlert AlertDataTable'>
        <h1 className='AlertDataTable-title'>{ closingsTitle }</h1>
        <table className='TableData'>
          <tr className='TableData-head hidden-xs'>
            <th>{translate('Name', language)}</th>
            <th>{translate('Status', language)}</th>
          </tr>
          {this._renderRow()}
        </table>
      </div>
    );
  }
}

class ClosingsButton extends Component {

  static propTypes = {
    category: PropTypes.string,
    activeBorder: PropTypes.bool
  }

  render() {
    const { category = '', activeBorder = false } = this.props;

    return (
      <div style = {{ border: activeBorder && '2px solid #000' }} className='ClosingsButton'>
        <div className='ClosingsButton-text'>
          { category.toUpperCase() }
        </div>
      </div>
    );
  }
}

class NoClosingsAlert extends Component {
  static propTypes = {
    noClosingsAlertMessage: PropTypes.string
  }

  render() {
    return (
      <div className='NoClosingsAlert'>
        {this.props.noClosingsAlertMessage}
      </div>
    );
  }
}


export default ClosingsAlert;



// WEBPACK FOOTER //
// ./app/components/news/ClosingsAlert.js